module.exports = __webpack_public_path__ + "img/background.3d501a27.webp";